<template>
  <div class="payments">
    <div class="content-wrapper">
      <RouterView />
    </div>
  </div>
</template>
